import {
    PRODUCT_INFO_REMOVE,
    UPDATE_QUERY_PRODUCT_SUCCESS, QueryProductUpdateAction,
} from "src/actions/QueryProductUpdateAction";
import { UpdateQueryProductResponse } from "src/model/QueryProduct";
import {SWITCH_AMAZON_STORE_START_NEW} from "src/actions/SelectedProductQueryAction";

const initialState: UpdateQueryProductResponse = {
    countryCode: 'US',
    queryProduct: null
};

export default (
    state: UpdateQueryProductResponse = initialState,
    action: QueryProductUpdateAction
): UpdateQueryProductResponse => {
    switch (action.type) {
        case UPDATE_QUERY_PRODUCT_SUCCESS:
            return {
                countryCode: action.countryCode,
                queryProduct: action.queryProduct
            };
        case PRODUCT_INFO_REMOVE:
        case SWITCH_AMAZON_STORE_START_NEW:
            return {
                countryCode: state.countryCode,
                queryProduct: null,
            };
        default:
            return state;
    }
};